import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ResetPassword from './ResetPassword';
import ResetPasswordConfirm from '../ResetPasswordConfirm/ResetPasswordConfirm';

const ResetPasswordContainer: React.FC = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  if (token) {
    return <ResetPasswordConfirm />;
  }
  return <ResetPassword />;
};

export default ResetPasswordContainer;